// extracted by mini-css-extract-plugin
module.exports = {"main":"terms-and-conditions_main__1n_PX","info":"terms-and-conditions_info__KtNNe"};